import { Component, OnInit } from '@angular/core';
declare var jQuery: any;
import '../../../assets/semantic/semantic.min.js';
import { OfferService } from '../../_services/offer.service';

@Component({
  selector: 'app-matching-demands-modal',
  templateUrl: './matching-demands-modal.component.html',
  styleUrls: ['./matching-demands-modal.component.css']
})
export class MatchingDemandsModalComponent implements OnInit {
  private offer;
  private demands: object[];
  private demands_count: number;
  private pinned_demands;
  private matching_levels = [false,
    { color: "green", text: "Parfait" },
    { color: "olive", text: "Très bon" },
    { color: "teal", text: "Très Bon (Retour)" },
    { color: "yellow", text: "Moyen" },
    { color: "orange", text: "Mauvais" },
    { color: "orange", text: "Mauvais (Retour)" },
    { color: "red", text: "Très Mauvais" },
    { color: "grey", text: "National" },
    { color: "grey", text: "National (retour)" }];

  constructor(private service: OfferService) { }

  ngOnInit() {

  }

  openModal(offer) {
    this.offer = offer;
    this.refresh();
    jQuery('#offers-mail-confirm-modal').modal({ inverted: true }).modal('hide'); // Hide the Confirmation Modal if it's Open
    jQuery('#matching-demands-modal').modal({ inverted: true, closable: false, allowMultiple: true }).modal('show');
  }

  openConfirmModal() {
    jQuery('#offers-mail-confirm-modal').modal({ inverted: true }).modal('show');
  }

  refresh() {
    this.service.getPinnedDemands(this.offer.id)
      .subscribe(response => {
        this.pinned_demands = response;
        this.service.getMatchingDemands(this.offer.id) // Get Contacts List
          .subscribe(response => {
            this.demands = response.demands;
            this.demands.forEach(function (demand) { // For Each Offer
              this.pinned_demands.forEach(function (pinned_demand) {
                if (pinned_demand.id === demand.id) { // Watch if it is in the Pinned Ones
                  Object.assign(demand, { pinned: true }); // And set the pinned attribute
                }
              })
            }.bind(this));
            this.demands_count = parseInt(response.total_count);   // Contact Count
          });
      });
  }

  pinDemand(demand_id) {
    // Envoyer la Requête
    this.service.pinUnpinDemand({ demand_id: demand_id, offer_id: this.offer.id })
      .subscribe(response => {
        if (response === 200) {
          this.refresh();
        }
      });
  }

  unpinDemand(demand_id) {
    // Envoyer la Requête
    this.service.pinUnpinDemand({ offer_id: this.offer.id, demand_id: demand_id })
      .subscribe(response => {
        if (response === 200) {
          this.refresh();
        }
      });
  }

  sendMail() {
    this.service.sendPinnedDemands(this.offer.id).subscribe();
    jQuery('#offers-mail-confirm-modal').modal({ inverted: true }).modal('hide'); // Hide the Confirmation Modal if it's Open
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/matching-demands-modal/matching-demands-modal.component.ts